import React from 'react';
import { Menu as AntMenu, Icon as AntIcon } from 'antd';
import PropTypes from 'prop-types';
import { get, some, includes, filter, isEmpty, size } from 'lodash';
import Link from '../../routes/Link';
import { Text, Icon } from '../../common';
import PendingPickingMenuItem from './PendingPickingMenuItem';
import PendingAuditMenuItem from './PendingAuditMenuItem';
import InvoicingMenuItem from './InvoicingMenuItem';
import LogoutMenuItem from './LogoutMenuItem';
import UserSession from '../../auth/UserSession';
import { Storage } from '../../utils';
import { autoLogout } from '../../../utils/awsAuth';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa';

let colorChange = '#1fa02e';

if (urlSisa() === urlBase()) {
    colorChange = '#4daea9';
}

const CustomMenuItems = { PendingPickingMenuItem, PendingAuditMenuItem, InvoicingMenuItem, LogoutMenuItem };
class Menu extends React.Component {
    state = {
        hovered: false,
        render: false,
        openKeys: ['']
    }

    rootSubmenuKeys = ['/orders-monitor-submenu', '/help-center-submenu', '/configs-submenu', '/users-submenu'];

    componentDidMount () {
        const { currentPathname } = this.props;
        const defaultOpenKeys = ['/users', '/profiles'].includes(currentPathname) ? ['/users-submenu'] : null;
        this.setState({
            render: true,
            defaultOpenKeys
        });
    }

    _renderMenuItemTitle = ({ icon, label, path, regex, collapsed, children = [] }) => {
        const { currentPathname } = this.props;
        const { hovered } = this.state;
        const isActive = size(children) ? some(children, ({ path }) => hovered === path) : currentPathname === path;
        const itemColor = isActive || (hovered === path) ? colorChange : '#ffffff';

        return (<>
            <AntIcon component={() => <Icon name={icon} color={itemColor} size={16} />} />
            <Text color={collapsed ? '#ffffff' : itemColor} text={label} />
        </>
        );
    }

    _renderMenuItem = ({ path, icon, regex, label, component = '' }, index) => {
        const { collapsed, currentPathname, onClickMenuItemCallback = () => {} } = this.props;
        const reloadWindow = () => (currentPathname === path) && location.reload();
        const CustomComponent = get(CustomMenuItems, component);
        const CleanFilterStorage = () => {
            if (includes('Pedidos', label)) {
                Storage.remove('selectedSla');
                Storage.remove('status');
                Storage.remove('salesChannel');
                Storage.remove('range');
                Storage.remove('fromRoomManagement');
            }
        };

        if (CustomComponent) {
            return (
                <CustomComponent key={index} index={path} onClick={reloadWindow} {...{ collapsed, path, icon, label, currentPathname }} />
            );
        }
        return (
            <AntMenu.Item
                key={index}
                onClick={reloadWindow, () => {
                    autoLogout();
                    CleanFilterStorage();
                    onClickMenuItemCallback();
                }}
                onMouseEnter={() => this.setState({ hovered: path })}
                onMouseLeave={() => this.setState({ hovered: null })}
            >
                <Link href={path} >
                    {this._renderMenuItemTitle({ icon, label, path, regex, collapsed })}
                </Link>
            </AntMenu.Item>
        );
    }

    _getAvaliableRoutes (routes, resources) {
        return filter(routes, ({ permissions }) =>
            isEmpty(permissions) || some(permissions, (resource) => includes(resources, resource)));
    }

    _loopOverMenuItems = (routes, resources) => {
        const availableRoutes = this._getAvaliableRoutes(routes, resources);
        return [...availableRoutes.map(({ children, ...item }, index) =>
            children ? this._renderNestedMenu({ ...item, children }, resources, index) : this._renderMenuItem(item, index)
        )];
    }
    _renderNestedMenu = ({ path, icon, label, regex, children }, resources, index) => {
        const title = this._renderMenuItemTitle({ icon, label, path, children, regex });
        return (
            <AntMenu.SubMenu
                key={path}
                title={title}
                onMouseEnter={() => this.setState({ hovered: path })}
                onMouseLeave={() => this.setState({ hovered: null })}
            >
                {this._loopOverMenuItems(children, resources)}
            </AntMenu.SubMenu>
        );
    }

    _getSelectedKeys = (routes, currentPathName) => {
        const testRoutes = (routes) => routes.reduce((acc, { children, regex, ...item }) => {
            acc = [].concat(acc, children ? testRoutes(children) : (regex.test(currentPathName) ? [item] : []));
            return acc;
        }, []);

        return testRoutes(routes).map(({ path }) => (path));
    }

    onOpenChange = openKeys => {
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.setState({ openKeys });
        } else {
          this.setState({
            openKeys: latestOpenKey ? [latestOpenKey] : []
          });
        }
    };

    _renderRoutes = () => {
        const { routes, currentPathname, collapsed } = this.props;
        const { render, defaultOpenKeys } = this.state;
        const defaultSelectedKeys = this._getSelectedKeys(routes, currentPathname);

        if (!render) return '';

        return (
            <UserSession typeCache>
                {({ resources }) => (
                    <AntMenu
                        forceSubMenuRender
                        inlineCollapsed={collapsed}
                        theme='dark'
                        mode='inline'
                        // defaultSelectedKeys={defaultSelectedKeys}
                        // defaultOpenKeys={defaultOpenKeys}
                        openKeys={this.state.openKeys}
                        onOpenChange={this.onOpenChange}
                    >
                        { [...this._loopOverMenuItems(routes, resources)] }
                    </AntMenu>
                )}
            </UserSession>
        );
    }

    render () {
        return this._renderRoutes();
    }
}

Menu.propTypes = {
    collapsed: PropTypes.bool,
    routes: PropTypes.array,
    currentPathname: PropTypes.string
};

export default Menu;
